import VBackCenter from './back-center.vue'
import VBackSearch   from './back-search.vue'
import vBack from './back.vue'
import VRelation from './relation.vue'

export default {
     VBackCenter,
     vBack,
     VBackSearch,
     VRelation
}


// WEBPACK FOOTER //
// ./src/common/index.js